module.exports = __webpack_public_path__ + "static/media/FireAlarm.eb3cb562.png";